import { Modal }          from '@widesk-ui/components/modal/Modal';
import { Action }         from '@widesk-ui/components/ButtonActions';
import { DeleteOutlined } from '@ant-design/icons';
import ApiModel           from '@widesk-core/models/ApiModel';
import PagedCollection    from '@widesk-core/models/PagedCollection';
import ApiCollection      from '@widesk-core/models/ApiCollection';
import { message }        from '@widesk-ui/hooks/useMessage';

type DeleteOptions = {
	mode?: 'unlink',
	callback?: () => void;
	title?: string;
	actionProps?: Partial<Action>;
};

const actionDeleteCollection = (
	collection: ApiCollection<ApiModel> | PagedCollection<ApiModel>,
	options?: DeleteOptions,
) => {
	const deleteModels = async () => {
		const coll = new PagedCollection(collection.model);

		await coll
			.setItemsPerPage(0)
			.setFilters(collection.filters)
			.list();

		const actionLabel = options?.mode === 'unlink' ? 'détaché' : 'supprimé';

		const choice = await Modal.confirm({
			title: coll.total === 1 ?
				`${coll.total} élément va être ${actionLabel}.` :
				`${coll.total} éléments vont être ${actionLabel}s.`,
			content: `Voulez-vous continuer ?`,
		});

		if (choice) {
			await collection.destroy();
			message.success(
				coll.total === 1 ?
					`${coll.total} élément a bien été ${actionLabel}.` :
					`${coll.total} éléments ont bien été ${actionLabel}s.`,
			);
			options?.callback?.();
		}
	};

	const defaultTitle = options?.mode === 'unlink' ?
		'Détacher tous les éléments' :
		'Supprimer toute la liste';

	return {
		hidden: collection.length === 0,
		danger: true,
		icon: <DeleteOutlined />,
		label: options?.title || defaultTitle,
		onClick: async () => deleteModels(),

		...options?.actionProps,
	};
};

export default actionDeleteCollection;
